import { Configuration } from './types';

export const config: Configuration = {
  portalApi: 'https://api.emergency.wa.gov.au/v1',
  portalEwaBffApi: 'https://api.portal.genvis.com/ewa/v1',
  mapbox: {
    token: 'pk.eyJ1Ijoicm9iZ2VudmlzIiwiYSI6ImNqajVqN2x4bDBjMzMzbHBlNHE3MGh3NjUifQ.KjxadPDKl38aMhzH3jVWpQ',
    overlaysTileSet: 'mapbox://robgenvis.ewa-overlays-prd',
    overlayTileSetLayers: {
      dfesRegions: 'dfes-regions-tileset-layer-prd',
      lga: 'lga-tileset-layer-prd',
      lgaCentres: 'lga-centres-tileset-layer-prd',
      pastoralStations: 'pastoral-stations-tileset-layer-prd',
    },
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://genvis.com/assets/icons/map/pins/40x40',
  },
  geospatialBucket: 'https://d3d5cp23hc6r4p.cloudfront.net',
  // TODO: Update these to the production URLs once they are available.
  // This is the Preflight instance of the EmergencyVic proxy server.
  windTileBaseUrl: 'https://d2qs3zxczgqy2f.cloudfront.net',
  // This is the Preflight instance of the BOM proxy server.
  externalTileBaseUrl: 'https://dcmf2mat0wkt1.cloudfront.net',
  webTemplateStyleSheetUrl: 'https://genvis.com/assets/styles/ewa-webtemplate.css',
  sentry: {
    // The production DSN is different from the base configuration. This is because this has
    // been setup with custom production-specific settings on genvis.sentey.io.
    // !NOTE: This has been disabled as part of the EWA mobile application go-live to prevent
    // quota exhaustion.
    // TODO: Re-visit this.
    dsn: 'https://49bc98a2766fe6c2d605f8353b010a2b@o4507253793816576.ingest.de.sentry.io/4507255077339216',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyARQ5yKmlnYA-55alwGXTjhwjH0cYPUQmA',
    authDomain: 'ewa-web-prd.firebaseapp.com',
    projectId: 'ewa-web-prd',
    storageBucket: 'ewa-web-prd.firebasestorage.app',
    messagingSenderId: '807399722073',
    appId: '1:807399722073:web:fe20525be9e3a1b310b548',
    measurementId: 'G-73SZD1YCZQ',
  },
  recaptcha: {
    siteKey: '6LdX4LwrAAAAAEUUOcrc5tmviqr5C0shr1VfSSZ-',
    enabled: true,
  },
  googleTagManager: {
    containerId: 'GTM-TZWFTLWF',
  },
  environment: 'prd',
};
